export default __webpack_public_path__ + "static/media/silverBadge.7caed324.svg";